import { CSSProperties, FC, ReactNode } from "react";
import { Card, Descriptions, Tag } from "antd";
import { clsx } from "clsx";
import { getColorFromLetter } from "../Color";
import classes from "./ListCard.module.less";

export type ListCardTagColor = "grey" | "green" | "blue" | "red" | "orange";

const tagColorClasses: Record<ListCardTagColor, string> = {
    grey: classes.tagGrey,
    green: classes.tagGreen,
    blue: classes.tagBlue,
    red: classes.tagRed,
    orange: classes.tagOrange,
};

export const ListCardTag: FC<{ color: ListCardTagColor; children: ReactNode }> = ({
    color,
    children,
}) => <Tag className={clsx(classes.tag, tagColorClasses[color])}>{children}</Tag>;

export interface ListCardField {
    label: string;
    content: ReactNode;
    span?: number;
}

interface ListCardProps {
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
    logo?: ReactNode;
    logoFallback?: string;
    fields: ListCardField[];
    actions?: ReactNode;
    columns?: number;
}

export const ListCard: FC<ListCardProps> = ({
    className,
    style,
    onClick,
    logo,
    logoFallback,
    fields,
    actions,
    columns = 10,
}) => {
    const fallbackLetter = (logoFallback || "?").charAt(0).toUpperCase();
    const fallbackColor = getColorFromLetter(fallbackLetter);
    const usedSpan = fields.reduce((sum, f) => sum + (f.span || 1), 0);
    const actionsSpan = columns - usedSpan;

    return (
        <Card className={clsx(classes.card, className)} style={style} onClick={onClick}>
            <div className={classes.logo}>
                {logo || (
                    <div
                        className={classes.logoFallback}
                        style={{ backgroundColor: fallbackColor }}
                    >
                        {fallbackLetter}
                    </div>
                )}
            </div>
            <div className={classes.content}>
                <Descriptions column={columns} colon={false} layout="vertical" size="small">
                    {fields.map((field) => (
                        <Descriptions.Item key={field.label} label={field.label} span={field.span}>
                            {field.content}
                        </Descriptions.Item>
                    ))}
                    {actions && actionsSpan > 0 && (
                        <Descriptions.Item label=" " span={actionsSpan}>
                            <div className={classes.actions}>
                                <div onClick={(e) => e.stopPropagation()}>{actions}</div>
                            </div>
                        </Descriptions.Item>
                    )}
                </Descriptions>
            </div>
        </Card>
    );
};
